/* Mobile / Desktop menu fix */

$(function(){

  /* Lang bar */

  $('#masthead .lang-bar .dropdown-toggle').on('click', function(){
    $(this).closest('.lang-bar').toggleClass('opened');

    return false;
  });

  $(document).click(function(){
    if($('#masthead .lang-bar').hasClass('opened')) {
      $('#masthead .lang-bar').removeClass('opened');
    }
  });

  $(document).on('click', '#masthead .lang-bar', function(e){
    e.stopPropagation();
  });

  /* /Lang bar */


  $('.floated-menu .close-menu').on('click', function(){
    $('#masthead .search-toggle').removeClass('hide');
    $('#masthead .menu-toggle').removeClass('open');
    $(this).closest('.floated-menu').removeClass('open');

    return false;
  });

  if($(document).width() <= 1199) {
    $('.floated-menu .nav-columns .menu > li').each(function(e){
      if($(this).find('> .sub-menu').length) {
        $(this).append('<span class="sub-toggle"></span>');
      }
    });
  }

  //$(document).on('click', '.floated-menu .nav-columns .menu li > a', function(){
  //$(this).toggleClass('opened');

  //if($(this).hasClass('opened')) {
  //		$(this).closest('li').find('.sub-menu').slideDown(150);
  //	} else {
  //		$(this).closest('li').find('.sub-menu').slideUp(150);
  //	}

  //	return false;
//	});



// A $( document ).ready() block.
  $( document ).ready(function() {



    $('#primary-menu li > a').on('click', function(){
      $(this).toggleClass('opened');

      if($(this).hasClass('opened')) {
        $(this).closest('li').find('.sub-menu').slideDown(150);
      } else {
        $(this).closest('li').find('.sub-menu').slideUp(150);
      }
//		return false;
    });
    $('#secondary-menu-1 li .sub-toggle').on('click', function(){
      $(this).toggleClass('opened');

      if($(this).hasClass('opened')) {
        $(this).closest('li').find('.sub-menu').slideDown(150);
      } else {
        $(this).closest('li').find('.sub-menu').slideUp(150);
      }
//		return false;
    });

    $('#secondary-menu-2 li .sub-toggle').on('click', function(){
      $(this).toggleClass('opened');

      if($(this).hasClass('opened')) {
        $(this).closest('li').find('.sub-menu').slideDown(150);
      } else {
        $(this).closest('li').find('.sub-menu').slideUp(150);
      }
//		return false;
    });

    $('#secondary-menu-3 li .sub-toggle').on('click', function(){
      $(this).toggleClass('opened');

      if($(this).hasClass('opened')) {
        $(this).closest('li').find('.sub-menu').slideDown(150);
      } else {
        $(this).closest('li').find('.sub-menu').slideUp(150);
      }
//		return false;
    });


//	$('.tab-drop li a').on('click', function(){
//		alert('wow');
//	});
//		return false;
    // console.log( "ready!" );

    $('.rb_custom_vid_article').click(function(){
      var vid_src = $(this).attr("vid-src");
      var vid_h = $(this).attr("vid-h");
      var vid_w = $(this).attr("vid-w");
      var ifr = $("<iframe></iframe>").attr("src",vid_src).attr("height",vid_h).attr("width",vid_w).attr("allowfullscreen","allowfullscreen");
      $(".rb_vid_box_content").html(ifr);
      $(".rb_overlay").fadeIn(400);
      //$(".rb_vid_box").css("top",(($(window).height()-vid_h)/2)+"px");
      $(".rb_vid_box").css("top","10%");
      $(".rb_vid_box_content").css("width",(vid_w)+"px");
      $(".rb_vid_box").css("width",(parseInt(vid_w)+40)+"px");
    });
    $(".close_rb_vid_box").click(function(event){
      event.preventDefault();
      $(".rb_overlay").fadeOut(400,function(){
        $(".rb_vid_box_content").html("");
      });
    });
  });

  $(window).resize(function() {
    if($(document).width() <= 1199) {
      if($('.floated-menu .nav-columns .menu li .sub-toggle').length == 0) {
        $('.floated-menu .nav-columns .menu > li').each(function(e){
          if($(this).find('> .sub-menu').length) {
            $(this).append('<span class="sub-toggle"></span>');
          }
        });
      }
    }
  });

  if($('.gallery .bxslider').length > 0) {
    $('.gallery .bxslider').bxSlider({
      controls: true,
      pager: false,
      slideMargin: 0
    });
  }

  /* Documents titles */

  $('table.documentation tr td').each(function(){
    if($(this).find('h2.documentation').length) {
      $(this).closest('tr').addClass('has-title');
    }
  });

  $('table.documentation h2.documentation').on('click', function(){
    $(this).toggleClass('opened');

    if($(this).hasClass('opened')) {
      $(this).closest('table').find('tr').not('.has-title').slideDown(200);
    } else {
      $(this).closest('table').find('tr').not('.has-title').slideUp(200);
    }

    return false;
  });

  /* Main site nav fix */

  $('#site-navigation li.menu-item-has-children').each(function(){
    $(this).find('> a').append('<i class="sub-toggle"></i>');
  });

  $('#site-navigation #primary-menu > li').each(function(number){
    if(number > 3) {
      $(this).addClass('tab-hide');
    }
  });

  if($(this).hasClass('menu-item-has-children')) {
    $(this).find('.sub-menu .menu-item-has-children').toggleClass('opened');
  }

  $(this).find('.sub-menu li').each(function(){
    if($(this).hasClass('opened')) {
      $(this).closest('li').find('.sub-menu').slideDown(250);
    } else {
      $(this).closest('li').find('.sub-menu').slideUp(150);
    }
  });
  $('#site-navigation #primary-menu > li').hover(function() {
      if($(document).width() >= 992) {

        if($(this).hasClass('menu-item-has-children')) {
          $(this).find('.sub-menu .menu-item-has-children').toggleClass('opened');
        }

        $(this).find('.sub-menu li').each(function(){
          if($(this).hasClass('opened')) {
            $(this).closest('li').find('.sub-menu').slideDown(250);
          } else {
            $(this).closest('li').find('.sub-menu').slideUp(150);
          }
        });
      }

    }, function() {
      if($(document).width() >= 992) {

        if($(this).hasClass('menu-item-has-children')) {
          $(this).find('.sub-menu .menu-item-has-children').toggleClass('opened');
        }

        $(this).find('.sub-menu li').each(function(){
          if($(this).hasClass('opened')) {
            $(this).closest('li').find('.sub-menu').slideDown(250);
          } else {
            $(this).closest('li').find('.sub-menu').slideUp(150);
          }
        });
      }
    }
  );


  /* RWD Menu */

  $('header#masthead .nav-toggle').on('click', function() {
    $(this).toggleClass('open');

    var documentWidth = $(document).width();

    if(documentWidth <= 1199 && documentWidth >= 992) {
      if($('#site-navigation .tab-drop li').length == 0) {
        $('#site-navigation #primary-menu li.tab-hide').each(function() {
          var liCont = $(this)[0].outerHTML;

          $('#site-navigation .tab-drop').append(liCont);
        });
        $( ".tab-drop li > a" ).click(function() {
          $(this).toggleClass('opened');

          if($(this).hasClass('opened')) {
            $(this).closest('li').find('.sub-menu').slideDown(150);
          } else {
            $(this).closest('li').find('.sub-menu').slideUp(150);
          }
        });
      }

      if($(this).hasClass('open')) {
        $('#site-navigation .tab-drop').slideDown(150);
      } else {
        $('#site-navigation .tab-drop').slideUp(150);
      }
    }

    if(documentWidth <= 991 && documentWidth > 780) {
      if($(this).hasClass('open')) {
        $('body').addClass('active');

        if($('body').hasClass('logged-in')) {
          $('header#masthead #site-navigation').animate({ top: '112px' }, 200);
        } else {
          $('header#masthead #site-navigation').animate({ top: '80px' }, 200);
        }

      } else {
        $('body').removeClass('active');
        $('header#masthead #site-navigation').animate({ top:'-100%' }, 150);
      }

    } else if(documentWidth <= 780) {
      if($(this).hasClass('open')) {
        $('body').addClass('active');

        if($('body').hasClass('logged-in')) {
          $('header#masthead #site-navigation').animate({ top: '126px' }, 200);
        } else {
          $('header#masthead #site-navigation').animate({ top: '80px' }, 200);
        }

      } else {
        $('body').removeClass('active');
        $('header#masthead #site-navigation').animate({ top:'-100%' }, 150);
      }
    }

    return false;
  });

  //if($(document).width() >= 992 && $(document).width() < 1200) {
  //		$(document).on('click', '#site-navigation .tab-drop li a .sub-toggle', function(){
  //		$(this).toggleClass('opened');

  //			if($(this).hasClass('opened')) {
//				$(this).closest('li').find('.sub-menu').slideDown(150);
// 			} else {
  //				$(this).closest('li').find('.sub-menu').slideUp(150);
// 			}

// 			return false;
// 		});
  //	}


// 	if($(document).width() <= 991) {
// 		$('#site-navigation #primary-menu li.menu-item-has-children a').on('click', function(){
// 			$(this).toggleClass('opened');
//
  //			if($(this).hasClass('opened')) {
//				$(this).closest('li').find('.sub-menu').slideDown(150);
  //			} else {
  //				$(this).closest('li').find('.sub-menu').slideUp(150);
  //			}

  //			return false;
// 		});
// 	}

  /*

  $(window).resize(function() {
   $('body, header#masthead .nav-toggle').removeClass('open active');
   $('.tab-drop').slideUp(150);

   $('header#masthead #site-navigation').animate({ top:'-100%' }, 150);
 });

 */

});


// WEBPACK FOOTER //
// ./js/dev/menu-fix.js